import { render, staticRenderFns } from "./ShareableLink.vue?vue&type=template&id=fff515e6"
import script from "./ShareableLink.vue?vue&type=script&lang=ts"
export * from "./ShareableLink.vue?vue&type=script&lang=ts"
import style0 from "./ShareableLink.vue?vue&type=style&index=0&id=fff515e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports